import { locale } from '@trqk/utils';
import _sum from 'lodash/sum';

export const defaultColumnWidth = 80;
export const headerHeight = 30;
export const modalFooterHeight = 80;
export const modalFooterShimHeight = 20;
export const modalWidth = 1000;
export const rowHeight = 50;
export const progressBarSpacer = 2;
export const scrollbarSpacer = 20;
export const tableHeight = 400;
export const visibleUploadRows = 5;

export const defaultTooltipPosition = 'right';

export const columnWidths = {
    expander: 32,
    name: 290,
    nameIndent: 25,
    pro: 80,
    role_type: 100,
    period: 160,
    earnings: 80,
    statements: 100,
    spacer: 40,
};

export const contentWidth = _sum(Object.values(columnWidths));

export const deleteStatementViewSuccessMessage = `
    ${
        locale.enUS.MANAGE_STATEMENTS.TOASTS.STATEMENT_DELETION_SUCCESS.PART_1
    }${' '}
    ${
        locale.enUS.MANAGE_STATEMENTS.TOASTS.STATEMENT_DELETION_SUCCESS
            .STATEMENT_WAS
    }${' '}
    ${locale.enUS.MANAGE_STATEMENTS.TOASTS.STATEMENT_DELETION_SUCCESS.PART_2}
`;

export const deleteStatementViewErrorMessage = `
    ${
        locale.enUS.MANAGE_STATEMENTS.TOASTS.STATEMENT_DELETION_FAILURE.PART_1
    }${' '}
    ${locale.enUS.MANAGE_STATEMENTS.TOASTS.STATEMENT_DELETION_FAILURE.STATEMENT}
`;
